module.exports = __webpack_public_path__ + "img/cloudlines.efe96e8f.png";